import type { OptionSpec, OptionValue } from '@campfire/engine';
import { h } from './dom.ts';

type Values = Readonly<Record<string, OptionValue>>;

/**
 * Settings page body, generated from a game's declared specs (ADR-0011).
 * Options are indexed so null and numeric choices survive the round trip through <select>.
 */
export function settingsForm(specs: readonly OptionSpec[], values: Values, onChange: (key: string, value: OptionValue) => void): HTMLElement {
  return h(
    'div.settings',
    {},
    specs.map((spec) => {
      const current = spec.choices.findIndex((c) => c.value === values[spec.key]);
      const select = h(
        'select',
        {
          'data-testid': `setting-${spec.key}`,
          onchange: () => onChange(spec.key, spec.choices[Number(select.value)]!.value),
        },
        spec.choices.map((c, i) => h('option', { value: i, selected: i === current }, c.label)),
      ) as HTMLSelectElement;
      return h('label.setting', {}, h('strong', {}, spec.label), spec.help ? h('span.muted', {}, spec.help) : null, select);
    }),
  );
}

/** One-line summary of the chosen values, e.g. "1 card · No limit". */
export function settingsSummary(specs: readonly OptionSpec[], values: Values): string {
  return specs.map((s) => s.choices.find((c) => c.value === values[s.key])?.label ?? String(values[s.key])).join(' · ');
}
